import {defineStore} from 'pinia'
import {http} from '@/extensions/http/index.js'
import {API_ENDPOINTS} from '@/config/index.js'

export const useCategoryStore = defineStore('category', {
    state: () => {
        return {
            all: null,
            sub_categories: null
        }
    },
    actions: {
        async init() {
            try {
                if (this.all) return

                const {data} = await http.get(API_ENDPOINTS.CATEGORY.INDEX)

                const [categories, sub_categories] = data.reduce((acc, category) => {
                    acc[category.parent_id ? 1 : 0].push(category)

                    return acc
                }, [[], []])

                this.all = categories
                this.sub_categories = sub_categories
            } catch { /**/ }
        },
        async uploadIcon(id, icon) {
            try {
                const formData = new FormData()
                formData.append('icon', icon)

                const {data} = await http.post(API_ENDPOINTS.CATEGORY.UPLOAD_ICON.replace(':id', id), formData)

                if (this.sub_categories.find(category => category.id.toString() === id.toString())) {
                    this.sub_categories = this.sub_categories.map(category => {
                        if (category.id.toString() === id.toString()) {
                            category.icon = data.data
                        }

                        return category
                    })
                }

                this.all = this.all.map(category => {
                    if (category.id.toString() === id.toString()) {
                        category.icon = data.data
                    }

                    return category
                })
                
            } catch { /**/ }
        },
        async destroy(id) {
            try {
                await http.delete(API_ENDPOINTS.CATEGORY.DESTROY.replace(':id', id))

                this.all = this.all.filter(category => category.id.toString() !== id.toString())
                this.sub_categories = this.sub_categories.filter(category => category.id.toString() !== id.toString())
            } catch { /**/ }
        },
        async store(payload) {
            try {
                const {data} = await http.post(API_ENDPOINTS.CATEGORY.STORE, payload)

                data.parent_id
                    ? this.sub_categories.push(data)
                    : this.all.push(data)

                return data.id    
            } catch { /**/ }
        },
        async update(id, payload) {
            try {
                const {data} = await http.put(API_ENDPOINTS.CATEGORY.UPDATE.replace(':id', id), payload)

                if (data.parent_id) {
                    this.sub_categories = this.sub_categories.map(category => {
                        if (category.id.toString() === id.toString()) {
                            category = data
                        }

                        return category
                    })
                }

                this.all = this.all.map(category => {
                    if (category.id.toString() === id.toString()) {
                        category = data
                    }

                    return category
                })

                return data.id
            } catch { /**/ }
        }
    }
})